__turbopack_context__.v({
  "tappableRow": "MobileServices-module-scss-module__ZIm9Da__tappableRow",
});
